import css from 'styled-jsx/css'
import { sizes } from '../../theme'

export default css`
  @media screen and (max-width: ${sizes.media.mobile.maxWidth}) {
    /* display: none; */
  }
`
